export const categoryData = {
  wanghong: {
    name: '网红黑料',
    slug: 'wanghong',
    description: '全方位追踪网红达人最新动态，深扒不为人知的黑料内幕。从直播间翻车到私下丑闻，每一条爆料都经过严格核实。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20social%20media%20influencer%20theme%20with%20smartphone%20screens%20glowing%20in%20darkness%2C%20mysterious%20digital%20atmosphere%2C%20warm%20amber%20accents%2C%20cinematic%20lighting%2C%20dark%20background%2C%20dramatic%20mood&width=1600&height=600&seq=category-wanghong-hero&orientation=landscape',
  },
  mingxing: {
    name: '明星塌房',
    slug: 'mingxing',
    description: '聚焦娱乐圈明星塌房事件，记录每一个从神坛跌落的震撼瞬间。从顶流翻车到老戏骨丑闻，吃瓜不停歇。',
    image: 'https://readdy.ai/api/search-image?query=Falling%20star%20metaphor%20with%20shattered%20glass%20effect%20on%20dark%20background%2C%20dramatic%20red%20and%20gold%20accents%2C%20cinematic%20mood%2C%20mysterious%20atmosphere%2C%20high%20contrast%20editorial&width=1600&height=600&seq=category-mingxing-hero&orientation=landscape',
  },
  dasai: {
    name: '每日大赛',
    slug: 'dasai',
    description: '每日更新最热门爆料大赛，实时追踪网络热议事件。黑料不停更，吃瓜不打烊，让你永远不错过任何一个大瓜。',
    image: 'https://readdy.ai/api/search-image?query=Countdown%20clock%20with%20dramatic%20glowing%20numbers%20on%20dark%20background%2C%20urgent%20newsroom%20vibe%2C%20warm%20amber%20and%20gold%20lighting%2C%20cinematic%20atmosphere%2C%20tense%20mood&width=1600&height=600&seq=category-dasai-hero&orientation=landscape',
  },
  video: {
    name: '吃瓜视频',
    slug: 'video',
    description: '独家爆料视频合集，直击第一现场。从偷拍到实锤，用影像还原每一个瓜的真相。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20camera%20lens%20with%20dramatic%20red%20recording%20light%20on%20dark%20background%2C%20mysterious%20film%20set%20atmosphere%2C%20warm%20golden%20accents%2C%20dark%20cinematic%20mood&width=1600&height=600&seq=category-video-hero&orientation=landscape',
  },
};

export const categoryArticles = {
  wanghong: [
    {
      id: 101, title: '知名网红直播间翻车，私下聊天记录遭曝光', category: '网红黑料', categorySlug: 'wanghong', date: '2026-07-07',
      image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20dramatic%20crash%20effect%2C%20dark%20atmosphere%2C%20warm%20amber%20lighting%2C%20mysterious%20vibe%2C%20cinematic%20style&width=600&height=400&seq=cat-wanghong-01&orientation=landscape',
      slug: 'zhiming-wanghong-zhibo-fanche',
    },
    {
      id: 102, title: '情侣网红分手互撕，双方各执一词爆出大量猛料', category: '网红黑料', categorySlug: 'wanghong', date: '2026-07-06',
      image: 'https://readdy.ai/api/search-image?query=Broken%20heart%20symbolism%20on%20dark%20background%2C%20dramatic%20lighting%2C%20two%20silhouettes%20facing%20away%2C%20cinematic%20mood&width=600&height=400&seq=cat-wanghong-02&orientation=landscape',
      slug: 'qinglv-wanghong-fenshou-husi',
    },
    {
      id: 103, title: '选秀冠军被爆学历造假，昔日采访言论被扒', category: '网红黑料', categorySlug: 'wanghong', date: '2026-07-05',
      image: 'https://readdy.ai/api/search-image?query=Graduation%20cap%20on%20dark%20surface%20with%20dramatic%20lighting%2C%20mysterious%20academic%20fraud%20theme%2C%20cinematic%20noir&width=600&height=400&seq=cat-wanghong-03&orientation=landscape',
      slug: 'xuanxiu-guanjun-xueli-zaojia',
    },
    {
      id: 104, title: '美食博主被曝使用过期食材，粉丝怒斥欺骗消费者', category: '网红黑料', categorySlug: 'wanghong', date: '2026-07-04',
      image: 'https://readdy.ai/api/search-image?query=Dark%20kitchen%20with%20spoiled%20food%20dramatic%20lighting%2C%20mysterious%20investigation%20mood%2C%20warm%20dark%20tones&width=600&height=400&seq=cat-wanghong-04&orientation=landscape',
      slug: 'meishi-bozhu-guoqi-shicai',
    },
    {
      id: 105, title: '健身网红被爆使用违禁药物，完美身材全靠科技', category: '网红黑料', categorySlug: 'wanghong', date: '2026-07-03',
      image: 'https://readdy.ai/api/search-image?query=Gym%20equipment%20in%20darkness%20with%20dramatic%20spotlight%2C%20mysterious%20atmosphere%2C%20warm%20amber%20tones%2C%20cinematic&width=600&height=400&seq=cat-wanghong-05&orientation=landscape',
      slug: 'jianshen-wanghong-weijin-yaowu',
    },
    {
      id: 106, title: '美妆博主带货翻车，直播间怒骂品牌方被录屏', category: '网红黑料', categorySlug: 'wanghong', date: '2026-07-02',
      image: 'https://readdy.ai/api/search-image?query=Makeup%20products%20scattered%20on%20dark%20surface%2C%20dramatic%20lighting%2C%20mysterious%20beauty%20scandal%20vibe&width=600&height=400&seq=cat-wanghong-06&orientation=landscape',
      slug: 'meizhuang-bozhu-daihuo-fanche',
    },
  ],
  mingxing: [
    {
      id: 201, title: '顶流男星深夜密会神秘女子，酒店同框照流出', category: '明星塌房', categorySlug: 'mingxing', date: '2026-07-07',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%2C%20paparazzi%20style%2C%20dramatic%20lighting%2C%20mysterious%20celebrity%20scandal%20vibe&width=600&height=400&seq=cat-mingxing-01&orientation=landscape',
      slug: 'dingliu-nanxing-shenye-mihui',
    },
    {
      id: 202, title: '某女星与前经纪公司解约内幕曝光，违约金数额惊人', category: '明星塌房', categorySlug: 'mingxing', date: '2026-07-06',
      image: 'https://readdy.ai/api/search-image?query=Legal%20documents%20on%20dark%20desk%20dramatic%20lighting%2C%20mysterious%20contract%20dispute%2C%20cinematic%20noir&width=600&height=400&seq=cat-mingxing-02&orientation=landscape',
      slug: 'nvxing-jingji-gongsi-jiuyue',
    },
    {
      id: 203, title: '知名导演潜规则女演员录音曝光，圈内炸锅', category: '明星塌房', categorySlug: 'mingxing', date: '2026-07-05',
      image: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20dark%20soundstage%2C%20dramatic%20spotlight%2C%20mysterious%20casting%20couch%20theme&width=600&height=400&seq=cat-mingxing-03&orientation=landscape',
      slug: 'zhiming-daoyan-qian-guize',
    },
    {
      id: 204, title: '某女团成员被爆与经纪人有不正当关系', category: '明星塌房', categorySlug: 'mingxing', date: '2026-07-04',
      image: 'https://readdy.ai/api/search-image?query=Kpop%20stage%20dark%20dramatic%20lighting%2C%20silhouettes%2C%20mysterious%20backstage%20scandal&width=600&height=400&seq=cat-mingxing-04&orientation=landscape',
      slug: 'nvtuan-chengyuan-jingjiren',
    },
    {
      id: 205, title: '说唱歌手吸毒实锤视频疯传，代言品牌连夜解约', category: '明星塌房', categorySlug: 'mingxing', date: '2026-07-03',
      image: 'https://readdy.ai/api/search-image?query=Dark%20music%20studio%20dramatic%20red%20lighting%2C%20hip%20hop%20scandal%20atmosphere%2C%20mysterious%20vibe&width=600&height=400&seq=cat-mingxing-05&orientation=landscape',
      slug: 'shuochang-geshou-xidu-shichui',
    },
    {
      id: 206, title: '老牌影帝被爆税务问题，工作室紧急发声明', category: '明星塌房', categorySlug: 'mingxing', date: '2026-07-02',
      image: 'https://readdy.ai/api/search-image?query=Tax%20documents%20on%20dark%20desk%20dramatic%20lighting%2C%20mysterious%20financial%20scandal%2C%20cinematic&width=600&height=400&seq=cat-mingxing-06&orientation=landscape',
      slug: 'laopai-yingdi-shuiwu-wenti',
    },
  ],
  dasai: [
    {
      id: 301, title: '今日最劲爆：某知名导演潜规则女演员录音曝光', category: '爆 · 每日大赛', categorySlug: 'dasai', date: '2026-07-07',
      image: 'https://readdy.ai/api/search-image?query=Film%20set%20dark%20dramatic%20lighting%2C%20mysterious%20casting%20atmosphere%2C%20cinematic%20scandal%20vibe&width=600&height=400&seq=cat-dasai-01&orientation=landscape',
      slug: 'zhiming-daoyan-qian-guize',
    },
    {
      id: 302, title: '热搜第一：某女团成员被爆与经纪人有不正当关系', category: '热 · 每日大赛', categorySlug: 'dasai', date: '2026-07-07',
      image: 'https://readdy.ai/api/search-image?query=Girl%20group%20performance%20dark%20stage%2C%20dramatic%20backstage%20scandal%20atmosphere&width=600&height=400&seq=cat-dasai-02&orientation=landscape',
      slug: 'nvtuan-chengyuan-jingjiren',
    },
    {
      id: 303, title: '疯狂刷屏：某说唱歌手吸毒实锤视频全网疯传', category: '爆 · 每日大赛', categorySlug: 'dasai', date: '2026-07-06',
      image: 'https://readdy.ai/api/search-image?query=Dark%20studio%20red%20dramatic%20lighting%2C%20hip%20hop%20scandal%2C%20mysterious%20vibe&width=600&height=400&seq=cat-dasai-03&orientation=landscape',
      slug: 'shuochang-geshou-xidu-shichui',
    },
    {
      id: 304, title: '某顶流小生夜店与多名女子亲密互动被拍', category: '热 · 每日大赛', categorySlug: 'dasai', date: '2026-07-06',
      image: 'https://readdy.ai/api/search-image?query=Nightclub%20neon%20lights%20dramatic%20shadows%2C%20celebrity%20party%20scandal%2C%20dark%20atmosphere&width=600&height=400&seq=cat-dasai-04&orientation=landscape',
      slug: 'dingliu-xiaosheng-yedian',
    },
    {
      id: 305, title: '某选秀爱豆被前女友发长文控诉出轨实锤', category: '爆 · 每日大赛', categorySlug: 'dasai', date: '2026-07-05',
      image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20with%20long%20text%20message%2C%20dark%20background%2C%20dramatic%20scandal%20reveal&width=600&height=400&seq=cat-dasai-05&orientation=landscape',
      slug: 'xuanxiu-aidou-chugui-shichui',
    },
    {
      id: 306, title: '网红夫妇被实锤假结婚炒作，背后MCN浮出水面', category: '热 · 每日大赛', categorySlug: 'dasai', date: '2026-07-05',
      image: 'https://readdy.ai/api/search-image?query=Wedding%20rings%20on%20dark%20surface%2C%20dramatic%20lighting%2C%20fake%20marriage%20scandal%20theme&width=600&height=400&seq=cat-dasai-06&orientation=landscape',
      slug: 'wanghong-fufu-jiajiehun',
    },
  ],
  video: [
    {
      id: 401, title: '实拍：某网红活动现场被粉丝当众质问黑历史', category: '吃瓜视频', categorySlug: 'video', date: '2026-07-06',
      image: 'https://readdy.ai/api/search-image?query=Crowd%20confrontation%20at%20public%20event%2C%20dramatic%20documentary%20style%2C%20dark%20background&width=600&height=400&seq=cat-video-01&orientation=landscape',
      slug: 'wanghong-huodong-bei-zhiwen',
    },
    {
      id: 402, title: '偷拍：某男团成员深夜酒吧与多名异性亲密互动', category: '吃瓜视频', categorySlug: 'video', date: '2026-07-05',
      image: 'https://readdy.ai/api/search-image?query=Nightclub%20neon%20lights%20dramatic%20shadows%2C%20celebrity%20hidden%20camera%20scandal&width=600&height=400&seq=cat-video-02&orientation=landscape',
      slug: 'nantuan-chengyuan-jiuba',
    },
    {
      id: 403, title: '独家视频：知名博主私下大骂粉丝录音曝光', category: '吃瓜视频', categorySlug: 'video', date: '2026-07-04',
      image: 'https://readdy.ai/api/search-image?query=Voice%20recorder%20on%20dark%20background%2C%20dramatic%20lighting%2C%20mysterious%20audio%20leak%20theme&width=600&height=400&seq=cat-video-03&orientation=landscape',
      slug: 'zhiming-bozhu-dama-fensi',
    },
    {
      id: 404, title: '爆料视频：某品牌代言人彩排现场怒摔话筒', category: '吃瓜视频', categorySlug: 'video', date: '2026-07-03',
      image: 'https://readdy.ai/api/search-image?query=Stage%20rehearsal%20dark%20dramatic%20lighting%2C%20broken%20microphone%2C%20angry%20celebrity%20moment&width=600&height=400&seq=cat-video-04&orientation=landscape',
      slug: 'pinpai-daiyanren-nushuai-huatong',
    },
  ],
};